<div class="mb-[30px]">
  <div class="mb-3">
    <label for="message">{{ 'notification-form.message' | translate }}</label>
  </div>
  <div class="relative">
    <textarea
      id="message"
      [formControl]="messageControl"
      placeholder="{{ 'notification-form.message-placeholder' | translate }}"
      (input)="removeEmojis($event)"
      maxlength="140"
      [ngClass]="{
        'alert-border message-alert-textarea':
          messageControl.invalid && messageControl.touched,
        'alert-text': messageControl.value?.length > 140
      }"
    >
    </textarea>
    <!-- counter -->
    <span
      class="opacity-70 text-xs absolute right-4 bottom-3"
      [ngClass]="{
        'alert-text': messageControl.value?.length > 140
      }"
    >
      {{ messageControl.value?.length || 0 }} / 140
    </span>
  </div>
  <!-- error message -->
  <div class="relative">
    <div
      class="form-alert alert-text absolute"
      [ngClass]="{
        'show-form-alert': messageControl.invalid && messageControl.touched
      }"
    >
      <fa-icon [icon]="'warning'"></fa-icon>
      {{ 'notification-form.message-error' | translate }}
    </div>
  </div>
</div>
